/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DeletingInputs */

const en_deleting = /** @type {(inputs: DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting…`)
};

const he_deleting = /** @type {(inputs: DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוחק…`)
};

/**
* | output |
* | --- |
* | "Deleting…" |
*
* @param {DeletingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const deleting = /** @type {((inputs?: DeletingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DeletingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deleting(inputs)
	return he_deleting(inputs)
});